export function formatCurrency(
  amount: number,
  currency = "KRW",
  locale = "ko-KR"
): string {
  const value = currency === "KRW" ? amount : amount / 100;
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    maximumFractionDigits: currency === "KRW" ? 0 : 2,
  }).format(value);
}

export function formatDate(
  date: string | Date | null | undefined,
  format: "short" | "medium" | "long" | "time" | "datetime" = "short"
): string {
  if (!date) return "";
  const d = new Date(date);
  if (isNaN(d.getTime())) return "";

  const options: Record<string, Intl.DateTimeFormatOptions> = {
    short:    { month: "numeric", day: "numeric" },
    medium:   { year: "numeric", month: "long", day: "numeric" },
    long:     { year: "numeric", month: "long", day: "numeric", weekday: "long" },
    time:     { hour: "2-digit", minute: "2-digit" },
    datetime: { month: "numeric", day: "numeric", hour: "2-digit", minute: "2-digit" },
  };

  return d.toLocaleDateString("ko-KR", options[format] ?? options.short);
}

export function formatRelativeTime(date: string | Date | null | undefined): string {
  if (!date) return "";
  const diff = Date.now() - new Date(date).getTime();
  const minutes = Math.floor(diff / 60_000);
  if (minutes < 1) return "방금 전";
  if (minutes < 60) return `${minutes}분 전`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}시간 전`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}일 전`;
  return formatDate(date, "medium");
}

export function formatNumber(num: number, locale = "ko-KR"): string {
  return new Intl.NumberFormat(locale).format(num);
}

export function formatDuration(minutes: number): string {
  if (minutes < 60) return `${minutes}분`;
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return m > 0 ? `${h}시간 ${m}분` : `${h}시간`;
}
